import { useEffect, useState } from 'react';

import { TokenexLinkType } from '../@types';
import { TokenexScriptUrl } from '../constants';
import { createLogLocal } from '../utils/createLogLocal';

const log = createLogLocal('useTokenex.ts');

// TODO:
// https://usehooks-ts.com/react-hook/use-script
const loadTokenex = (mode: TokenexLinkType = 'live', reload = false) =>
  new Promise<void>(resolve => {
    if (!reload && (window as any).TokenEx) {
      log('Tokenex already Loaded.');
      resolve();
    }

    const script = document.createElement('script');
    script.src = TokenexScriptUrl[mode] || TokenexScriptUrl.live;
    script.async = true;

    script.addEventListener('load', async () => {
      log('Tokenex loaded.');
      resolve();
    });

    document.body.appendChild(script);
  });

export const useTokenex = (mode: TokenexLinkType) => {
  const [tokenexLoaded, setTokenexLoaded] = useState<boolean>(false);

  useEffect(() => {
    loadTokenex(mode).then(() => {
      setTokenexLoaded(true);
    });
  }, [mode]);

  return {
    tokenexLoaded,
  };
};
